// removed by extract-text-webpack-plugin
module.exports = {"option":"sideNav__option__3LWaZ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/Sidenav/sideNav.css
// module id = 802
// module chunks = 0